module.exports = __webpack_public_path__ + "img/android-clear-history.254421f.webp";